exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n  margin-bottom: 4rem; }\n\n.anchor {\n  visibility: hidden;\n  position: relative;\n  top: -8rem; }\n\n.highlight {\n  color: #07684F !important; }\n\n.highlight-less {\n  color: #188C71 !important; }\n\n.highlight-background {\n  background-color: #FBD9BC !important; }\n\n.caption {\n  margin-bottom: 10px; }\n\npre {\n  padding-top: 2rem !important;\n  background-color: initial !important;\n  border-color: #FBD9BC; }\n  pre:before {\n    background: #FBD9BC !important;\n    color: #07684F !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./demo/styles.scss
// module id = 25
// module chunks = 0